class ModalDialog extends HTMLElement {
  connectedCallback() {
    if (this.bound) return;
    this.bound = true;

    const closeBtn = this.querySelector('[id^="ModalClose-"]');
    if (closeBtn) closeBtn.addEventListener('click', () => this.hide());

    this.addEventListener('keyup', (event) => {
      if (event.code && event.code.toUpperCase() === 'ESCAPE') this.hide();
    });

    // Arka plana (overlay) tıklanınca kapat
    this.addEventListener('click', (event) => {
      if (event.target === this) this.hide();
    });

    // Modal'ı body'ye taşı (z-index/overflow izolasyonu için)
    if (!this.moved) {
      this.moved = true;
      document.body.appendChild(this);
    }
  }

  show(opener) {
    this.openedBy = opener;
    document.documentElement.setAttribute('scroll-lock', '');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');

    const dialog = this.querySelector('[role="dialog"]');
    if (dialog) dialog.focus();
  }

  hide() {
    document.documentElement.removeAttribute('scroll-lock');
    document.body.classList.remove('overflow-hidden');
    this.removeAttribute('open');
    if (this.openedBy && typeof this.openedBy.focus === 'function') {
      this.openedBy.focus();
    }
  }
}

if (!customElements.get('modal-dialog')) customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  connectedCallback() {
    if (this.bound) return;
    this.bound = true;

    const button = this.querySelector('button');
    if (!button) return;

    button.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal && typeof modal.show === 'function') modal.show(button);
    });
  }
}

if (!customElements.get('modal-opener')) customElements.define('modal-opener', ModalOpener);

/*
 * Yedek: custom element'ler herhangi bir sebeple upgrade edilmezse (script timing),
 * delegasyonla yine de modal'ı aç. Çift binding'i `data-modal-fallback-bound` engeller.
 */
document.addEventListener('click', (event) => {
  const opener = event.target.closest('modal-opener[data-modal]');
  if (!opener) return;
  // Custom element zaten bağladıysa (bound) tekrar tetikleme
  if (opener.bound) return;
  event.preventDefault();
  const modal = document.querySelector(opener.getAttribute('data-modal'));
  if (modal && typeof modal.show === 'function') modal.show(opener.querySelector('button'));
});
